import {Component, OnInit, AfterViewInit} from '@angular/core';
import {DialogsService} from '../../services/dialog.service';
import {UtilitiesService} from '../../services/utilities.service';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit,
    AfterViewInit {
  quotes: any[];
  recentQuotes: any[];
  orders: any[];
  recentOrders: any[];
  privateLabelDocuments: any[];
  sidebar: any;

  totalSavings = 0;
  loadingOrders = false;
  loadingQuotes = false;
  loadingTotalSavings = false;
  noRecordAttached = false;
  selectedState = 'AZ';

  isBeforeCutoffDate = true;

  constructor(private dialogService: DialogsService,
              private realtorPortalService: RealtorPortalService) {}

  ngOnInit() {
    var today = new Date();
    var cutoff = new Date(2023, 1, 1);

    if (today >= cutoff)
      this.isBeforeCutoffDate = false;

    this.loadingQuotes = true;
    this.realtorPortalService.getQuotes().then(quotes => {
      this.quotes = quotes;
      if (quotes.length <= 3) {
        this.recentQuotes = quotes;
      } else {
        this.recentQuotes = [];
        for (let i = 0; i < 3; i++) {
          this.recentQuotes.push(quotes[i]);
        }
      }
      this.doSetup();
      this.loadingQuotes = false;
    });

    this.loadingOrders = true;
    this.realtorPortalService.getOrders().then(orders => {
      this.orders = orders;
      this.doSetup();
      this.loadingOrders = false;

      if (orders.length <= 3) {
        this.recentOrders = orders;
      } else {
        this.recentOrders = [];
        for (let i = 0; i < 3; i++) {
          this.recentOrders.push(orders[i]);
        }
      }
    });

    this.loadingTotalSavings = true;
    this.realtorPortalService.getTotalSavingsByTrade().then(savingsByTrade => {
      if (savingsByTrade && savingsByTrade.length > 0) {
        this.totalSavings = savingsByTrade.map(i => i.EstimatedRetailCost)
                                .reduce((a, b) => a + b);
      }
      this.loadingTotalSavings = false;
    });

    this.realtorPortalService.getSideBarInfo().then(sidebar => {
      this.sidebar = sidebar;
      this.selectedState = sidebar.State;
      this.doSetup();
      if (!sidebar.WebUserId) {
        this.noRecordAttached = true;
      } 
    });

    this.realtorPortalService.getPrivateLabelDocuments().then(documents => {
      console.log(documents);
      this.privateLabelDocuments = documents;
    });
  }

  ngAfterViewInit() {}

  get baseUrl(): string { return UtilitiesService.baseAPIUrl; }

  doSetup() {
    if (this.orders && this.quotes && this.sidebar) {
      setTimeout(UtilitiesService.setupDocumentForAnimation(), 100);
    }
  }
}
